import { FlexInfoResponse } from 'Types/common';

export const NOT_RENDER_INCREASE_DISCOUNT_MIN = 4000;
export const NOT_RENDER_INCREASE_DISCOUNT_MAX = 7000;

export const calculateDiscount = (data: FlexInfoResponse): number => {
  if (data?.discount?.amountOff) {
    return data.discount.amountOff;
  }
  if (data?.discount?.percentOff && data?.price) {
    const discountAmount = (data.price * data.discount.percentOff) / 100;
    return Math.floor(discountAmount);
  }
  return 0;
};

export const calculatePercentage = (partialValue: number, totalValue: number): number => {
  if (totalValue === 0) return 0;
  return Math.floor((partialValue / 100 / totalValue) * 100);
};
